import { render, staticRenderFns } from "./EducationsDropdown.vue?vue&type=template&id=20b123c7&scoped=true"
import script from "./EducationsDropdown.vue?vue&type=script&lang=js"
export * from "./EducationsDropdown.vue?vue&type=script&lang=js"
import style0 from "./EducationsDropdown.vue?vue&type=style&index=0&id=20b123c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b123c7",
  null
  
)

export default component.exports